<template>
    <tbody class="bg-white">
    <tr>
        <td colspan="4" class="px-2 pt-2 pb-0 text-xs text-wrap font-bold w-40">
            {{ item.product.description }}
        </td>
    </tr>
    <tr>
        <td class="p-2 whitespace-nowrap text-xs leading-4 font-medium text-gray-90"
            :class="{'border-b border-gray-200': index < itemsCount-1}"
        >
            <div>
                {{ item.product.item_code }}
            </div>
        </td>
        <td class="p-2 whitespace-nowrap text-xs leading-4 font-medium text-gray-90 hidden md:table-cell"
            :class="{'border-b border-gray-200': index < itemsCount-1}"
        >
            {{ item.product.units[item.unit].pack_size }}
        </td>
        <td class="flex items-center p-2 whitespace-nowrap text-xs leading-normal font-medium text-gray-90 w-32 text-right md:table-cell"
            :class="{'border-b border-gray-200': index < itemsCount-1}"
        >
            <input type="number" v-model="qty" @change="sync"
                   class="form-input p-1 text-right w-25"/>
            <span class="px-2 w-25">{{ item.unit }}</span>

        </td>
        <td class="p-2 whitespace-nowrap text-xs text-right leading-4 font-medium text-gray-90 "
            :class="{'border-b border-gray-200': index < itemsCount-1}"
        >
            <button v-if="item.product.id" class="text-red-600" type="button" @click="removeItem">
                <icon name="trash" class="w-4 h-4 fill-current"/>
            </button>
        </td>
    </tr>
    </tbody>
</template>
<script>
  import Icon from '@/Shared/Icon'
  import store from '@/Shared/store.js'

  export default {
    name: 'OrderTableItem',
    components: {Icon},
    props: {
      index: {},
      item: {},
    },

    watch: {
      'item.qty': {
        handler: function (val) {
          if (val) {
            // console.log('change', val)
            this.qty = val
          } else {
            this.qty = 0
          }
        },
      }
    },

    data() {
      return {
        qty: this.item.qty,
        unit: this.item.unit
      }
    },

    methods: {
      sync() {
        store.updateQty({qty: parseFloat(this.qty), unit: this.unit, product: this.item.product})

        this.qty = store.qtyForItemUnit(this.item.product.id, this.unit)
      },

      removeItem() {
        store.removeItem(this.item)
      }
    },

    computed: {
      itemsCount() {
        return store.form.items.length
      }
    }
  }
</script>
